import {createContext} from 'react'
import type {ComponentType, ReactNode} from 'react'

export type Icon = ComponentType<{size?: number; className?: string; 'aria-hidden'?: boolean}>
export type ChildrenProps = {
  /** Content rendered inside this part of the sidebar. */
  children: ReactNode
}

export const GroupedContext = createContext(false)
